

















import Vue from 'vue';
import { DocumentModel, DocumentPagePreferencesModel, ThumbnailSearchModel, ThumbnailViewModel } from '@/types';
import MStoreThumbnailView from '@/components/shared/MStoreThumbnailView.vue';
import { DocumentConstants } from '@/types/constants';
import { ArrayUtils } from '@/utils';
import { mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  name: 'MStoreThumbnailFirstLastView',
  components: {
    MStoreThumbnailView
  },
  props: {
    document: {
      type: Object as () => DocumentModel,
      required: true
    },
    pages: {
      type: Array as () => number[],
      required: false
    },
    firstPageText: {
      type: String,
      default: 'First Page'
    },
    lastPageText: {
      type: String,
      default: 'Last Page'
    },
    middlePagesText: {
      type: String
    },
    maximumImageHeight: {
      type: Number,
      default: 150
    }
  },
  computed: {
    ...mapGetters('thumbnailStore', ['getThumbnail', 'getAllThumbnails']),
    aSeriesPaperAspectRatio(): number {
      return DocumentConstants.ASeriesPaperAspectRatio;
    },
    containerStyle(this: any): string {
      return `width: calc(${this.maximumImageHeight * this.aSeriesPaperAspectRatio}px + 2.1em);`;
    },
    getMiddlePagesText(this: any): string {
      if (this.middlePagesText) {
        return this.middlePagesText;
      }

      if (this.thumbnails.length === 3) {
        return 'Page 2';
      }

      const allPages = this.thumbnails.map((x: ThumbnailViewModel) => x?.page);
      const middlePages = allPages.slice(1, allPages.length - 1);

      if (ArrayUtils.isContiguous(middlePages)) {
        return `Pages ${middlePages[0]}-${middlePages[middlePages.length - 1]}`;
      }

      return ArrayUtils.getContiguousText(middlePages);
    },
    thumbnails(this: any) {
      const pageNums = this.pages || Array.from({ length: this.document.totalPages });

      return pageNums?.map((pageNum: number, index: number) => {
        const thumbnailPageNumber = pageNum || index + 1;
        const thumbnailInStore = this.getAllThumbnails.find(
          (x: ThumbnailViewModel) => x.cabinetId === this.document.cabinetId && x.documentId === this.document.id && x.page === thumbnailPageNumber
        );

        if (!thumbnailInStore) {
          const searchModel = {
            documentId: this.document.id,
            cabinetId: this.document.cabinetId,
            page: thumbnailPageNumber,
            maximumHeightInPixels: Math.floor(this.maximumImageHeight),
            maximumWidthInPixels: Math.floor(this.maximumImageHeight * this.aSeriesPaperAspectRatio)
          } as ThumbnailSearchModel;

          this.setThumbnail(searchModel);
        }
        const pageRotationPreferences = this.document.documentPagePreferences?.find((x: DocumentPagePreferencesModel) => x.page === thumbnailPageNumber);
        const thumbnailClone: ThumbnailViewModel = thumbnailInStore ? { ...thumbnailInStore } : ({ page: thumbnailPageNumber } as ThumbnailViewModel);
        thumbnailClone.documentPagePreference = pageRotationPreferences ? { ...pageRotationPreferences } : null;

        return thumbnailClone;
      });
    }
  },
  methods: {
    ...mapActions('thumbnailStore', ['setThumbnail']),
    getLabelAndPageNumberText(text: string, thumbnail: ThumbnailViewModel): string {
      return `${text} (${thumbnail?.page})`;
    }
  }
});
